<template>
  <div v-if="menuItems">
    <u-dropdown :items="menuItems" :popper="{ placement: 'top-end' }" @click.native.stop>
      <u-button :disabled="disabled" :icon="COMMON_ICONS.moreVertical" size="xs" :variant="variant" :color="color" class="opacity-70 hover:opacity-100 transition-all" />
    </u-dropdown>
  </div>
</template>

<script setup>
  const props = defineProps({
    album: Object,
    disabled: Boolean,
    color: {
      type: String,
      default: 'charcoal'
    },
    variant: {
      type: String,
      default: 'ghost'
    }
  });

  const {getContextActions} = useAlbumActions();

  const actions = getContextActions({
    album: props.album,
    userId: props.album.user_id
  });

  const modes = {
    owner: [
      [
        actions.share,
        actions.edit,
        actions.move,
        actions.download
      ],
      [
        actions.editThumbnail,
        actions.editCustomCover
      ],
      [
        actions.delete
      ]
    ],
    visitedShare: [
      [
        actions.copy,
        actions.download
      ],
      [
        actions.removeVisited
      ]
    ],
    general: [
      [
        actions.copy,
        actions.download
      ]
    ]
  };

  const mode = computed(() => {
    const {isAuthenticated, currentUserId} = useSessionStore();
    if (!isAuthenticated) {
      return false;
    }

    if (props.album.user_id === currentUserId) {
      return 'owner';
    } else if (props.album.sharedItemId) {
      return 'visitedShare';
    } else {
      return 'general';
    }
  });

  const menuItems = computed(() => modes[mode.value]);

</script>
